module.exports = __webpack_public_path__ + "img/back-arrow.50135933.png";